export default [
    {
        path: '/berita-acara',
        redirect: '/berita-acara',
        name: 'beritaAcara',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'beritaAcaraIndex',
                component: () => import('@/views/beritaAcara/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'beritaAcara',
                    pageTitle: 'Berita Acara',
                    breadcrumb: [
                        {
                            text: 'Berita Acara',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]